import { useState } from 'react'

import { useTenant } from '@rewardops/auth/src/client/use-tenant'

type TenantStylesConfig = {
  hover?: boolean
  hoverColor?: string
}

export const useTenantStyles = (
  config: TenantStylesConfig = {
    hover: false,
  },
) => {
  const { hoverColor } = config
  const tenant = useTenant()
  const [isHovered, setIsHovered] = useState(false)

  let style = {}

  let handlers = {}

  if (config.hover) {
    style = {
      ...style,
      backgroundColor: isHovered
        ? hoverColor
          ? hoverColor
          : tenant.primaryColor
        : 'initial',
    }
    handlers = {
      onMouseEnter: () => {
        setIsHovered(true)
      },
      onMouseLeave: () => {
        setIsHovered(false)
      },
    }
  } else {
    style = {
      backgroundColor: tenant.primaryColor,
    }
  }

  return {
    style,
    ...handlers,
  }
}
